import { render, staticRenderFns } from "./FreshChatTable.vue?vue&type=template&id=5dce44ec&scoped=true"
import script from "./FreshChatTable.vue?vue&type=script&lang=js"
export * from "./FreshChatTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce44ec",
  null
  
)

export default component.exports